import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import { getSelectedLocation } from '../../../utils'
import { toast } from 'react-toastify'
import { useIntl } from 'react-intl'
import useApiService from '../../../app/services/ApiService/ApiService'

function DeleteModal({
  showModal,
  setShowModal,
  item,
  url,
  data,
  setColumnItems,
  bodyTitle,
  bodyContent,
}: any) {
  const { deleteRequest, loading } = useApiService()
  // Dil
  const intl = useIntl()
  const t = (id: any, values = {}) => intl.formatMessage({ id }, values)
  const handleCloseModal = () => {
    setShowModal(false)
  }

  const handleDelete = async () => {
    const selectedLocation = getSelectedLocation()
    try {
      const response = await deleteRequest(
        `/netway-v2/${url}/${item.id}`,
        {},
        {
          'location-id': `${selectedLocation?.id}`,
        }
      )
      if (response.is_success === true) {
        setShowModal(false)
        toast.success(t('delete_success'))
        const updatedData = data.filter((otherItem: any) => otherItem.id !== item.id)
        setColumnItems(updatedData)
      } else {
        toast.error(t('alert2'))
      }
    } catch (error) {
      console.error('Error fetching:', error)
    }
  }

  return (
    <Modal show={showModal} onHide={handleCloseModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('delete_warning')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {bodyTitle ? bodyTitle : t('title')}: <span className='fw-bold'>{bodyContent}</span>
      </Modal.Body>
      <Modal.Footer className='justify-content-center gap-6'>
        <Button variant='secondary' onClick={handleCloseModal}>
          {t('no')}
        </Button>
        <Button variant='danger' onClick={handleDelete} disabled={loading}>
          {!loading && <span className='indicator-label'>{t('yes')}</span>}
          {loading && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              {t('please_wait')}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteModal
